export default __webpack_public_path__ + "static/media/user-green.c8424c9b.svg";